/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PartnersPageQuery = {
    readonly partners: {
        readonly items: ReadonlyArray<{
            readonly bottomTitle: string | null;
            readonly bottomText: string | null;
            readonly file: string | null;
            readonly fileTitle: string | null;
            readonly fileSize: number;
            readonly fileLastUpdateDate: unknown;
            readonly bottomText2: string | null;
            readonly _children: {
                readonly items: ReadonlyArray<{
                    readonly _id?: string;
                    readonly _name?: string | null;
                    readonly _createDate?: unknown;
                    readonly partnerSiteUrl?: string | null;
                    readonly picture?: string;
                    readonly section?: ReadonlyArray<{
                        readonly _id?: string;
                        readonly title?: string;
                    } | null> | null;
                } | null> | null;
            } | null;
            readonly sections: ReadonlyArray<{
                readonly _id?: string;
                readonly title?: string;
                readonly _umbDocumentParents?: {
                    readonly items: ReadonlyArray<{
                        readonly _name?: string | null;
                        readonly _createDate?: unknown;
                        readonly partnerSiteUrl?: string | null;
                        readonly picture?: string;
                    } | null> | null;
                } | null;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PartnersPageQuery";
};
export type PartnersPageQuery$data = PartnersPageQuery;
export type PartnersPageQuery$key = {
    readonly " $data"?: PartnersPageQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"PartnersPageQuery">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_createDate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partnerSiteUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PartnersPageQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PartnersPublishedContentConnection",
      "kind": "LinkedField",
      "name": "partners",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PartnersPublishedContent",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bottomTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bottomText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "file",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileLastUpdateDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bottomText2",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "orderBy",
                  "value": "_updateDate_DESC"
                }
              ],
              "concreteType": "PublishedContentConnection",
              "kind": "LinkedField",
              "name": "_children",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v3/*: any*/),
                        (v4/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "section",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v0/*: any*/),
                                (v5/*: any*/)
                              ],
                              "type": "PartnerSectionPublishedContent",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "PartnerPublishedContent",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "_children(orderBy:\"_updateDate_DESC\")"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "sections",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    (v5/*: any*/),
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "orderBy",
                          "value": "_createDate_DESC"
                        }
                      ],
                      "concreteType": "PublishedContentConnection",
                      "kind": "LinkedField",
                      "name": "_umbDocumentParents",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "items",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v1/*: any*/),
                                (v2/*: any*/),
                                (v3/*: any*/),
                                (v4/*: any*/)
                              ],
                              "type": "PartnerPublishedContent",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "_umbDocumentParents(orderBy:\"_createDate_DESC\")"
                    }
                  ],
                  "type": "PartnerSectionPublishedContent",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PublishedContentByTypeQuery",
  "abstractKey": null
};
})();
(node as any).hash = '3b073821ba3c5930ebdac91cb99a9bb6';
export default node;
